<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";

export default {
    components: { Layout, PageHeader, Swal },
    data() {
        return {
            title: "Medidas",
            items: [
                {
                    text: "Home",
                    href: "/"
                },
                {
                    text: "medidas",
                    active: true
                }
            ],
            medidas:{},
            medida:null,
            isLoading:false,
            datos:{
                name:'',
                codigo:'',
            }
        };
    },
    methods: {
        get_data(){
            this.isLoading=true
            try {
                axios.get('/api/medidas').then(res=>{
                    this.medidas = res.data.datos;
                    this.$toasted.success('Datos cargados!');
                })  
            } catch (e) {
                console.log(e);
                this.$toasted.error('Error al cargar datos!');
            } finally {
                this.isLoading=false
            }
        },
        agregar(){
            this.isLoading=true
            axios.post('/api/medidas',this.datos).then(res=>{
                if(res.data.estado){
                    this.medida = res.data.medida;
                    this.datos.name=''
                    this.datos.codigo=''
                    this.get_data()
                }else{
                    Swal.fire({
                            //position: "top-end",
                            icon: "warning",
                            title: "Error al agregar",
                            text: '',
                            showConfirmButton: true,
                            timer: 5000
                        });
                }
                this.isLoading=false
            })
        },
        eliminar(id){
            this.isLoading=true
            axios.delete('/api/medidas/'+id).then(res=>{
                this.medidas = res.data.datos;
                this.get_data()
                this.isLoading=false
            })
        }
    },
    mounted() {
        this.get_data()
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <table class="table">
                            <thead>
                                <th class="py-0 px-1">#</th>
                                <th class="py-0 px-1">NOMBRE</th>
                                <th class="py-0 px-1">CODIGO</th>
                                <th class="py-0 px-1"></th>
                            </thead>
                            <tbody>
                                <tr v-for="(m, i) in medidas" :key="i">
                                    <td class="py-0 px-1">{{ i + 1 }}</td>
                                    <td class="py-0 px-1">{{ m.name }}</td>
                                    <td class="py-0 px-1">{{ m.codigo }}</td>
                                    <td class="py-0 px-1">
                                        <div class="btn-group">
                                            <a @click="eliminar(m.id)" class="btn btn-danger btn-sm py-1 px-2">
                                                <i class="fas fa-trash"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Nombre">
                            <b-form-input for="text" placeholder="Nombre" v-model="datos.name"  ></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Codigo">
                            <b-form-input for="text" placeholder="Codigo" v-model="datos.codigo"  ></b-form-input>
                        </b-form-group>
                        <b-button v-show="datos.name!=='' && datos.codigo!==''" block variant="success" @click="agregar()">Agregar</b-button>
                        <loading-message v-if="isLoading" />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
